/* Bóveda: el botón de agregar confirma y dice si lo elegido ya está en el carrito o en el regalo. Se carga en toda la tienda; sin nada suelto en el carrito ni modo regalo solo escucha, y usa el carrito que la guardia ya leyó. */
(function () {
  if (window.bnBoton) return;
  var BOTON = '.product-form__submit, .quick-add__submit, [data-bn-dx-add], [data-bn-dj-add]';
  var SPANS = '.product-form__submit span, .quick-add__submit span, [data-bn-dx-add] span, [data-bn-dj-add] span';
  var RE = /^(Añadir al carrito|Agregar al carrito|Agregar otro(?: al regalo(?: \d+)?)?|Agregar al regalo(?: \d+)?)(.*)$/i;
  var HANDLE = (/\/products\/([^\/?#]+)/.exec(location.pathname) || [])[1] || '';
  var ORIGEN = new WeakMap();
  var cart = window.__bnCarrito || null, conf = null, tocado = null, visto = false, obs = null, enCola = false;
  function modo() { return window.bnRegaloModo ? window.bnRegaloModo.leer() : null; }
  function props(l) { return l.properties || {}; }
  function opcion(f) { return f.con ? 'Con ' + f.con.charAt(0).toLowerCase() + f.con.slice(1) : ''; }
  /* Lo suelto: sin regalos ni sus empaques. Dije + cadena cuenta como el dije. */
  function sueltas(c) {
    return ((c && c.items) || []).filter(function (l) { return !props(l)._regalo_id && !props(l)['Para el dije']; }).map(function (l) {
      return { clave: l.key, linea: l, con: props(l).Con || '', cantidad: l.quantity };
    });
  }
  function regalo(m) { var B = window.BNRegalo; return B && cart ? B.grupoDe(cart, m.id) : null; }
  function numero(m, g) { var B = window.BNRegalo; return g ? g.ver : B && cart ? B.mayorNumero(cart) + 1 : m.num; }
  /* Qué filas son de este botón, y si lo elegido ahora ya está. */
  function contexto(btn, filas) {
    var principal = !btn.closest('quick-add-modal, .card-wrapper, .card, .quick-add');
    var delProducto = function (f) { return principal && HANDLE && f.linea.handle === HANDLE; };
    var vid = function (f) { return String(f.linea.variant_id); };
    var dx = btn.closest('.bn-dx'), dj = btn.closest('.bn-dj');
    if (dx) {
      var todas = [], elegidas = [];
      dx.querySelectorAll('.bn-dx__opt').forEach(function (o) {
        todas.push(o.dataset.vid);
        if (parseInt(o.querySelector('[data-n]').textContent, 10) > 0) elegidas.push(o.dataset.vid);
      });
      return { principal: principal, dx: true, filas: filas.filter(function (f) { return delProducto(f) || todas.indexOf(vid(f)) > -1; }), otro: filas.some(function (f) { return elegidas.indexOf(vid(f)) > -1; }) };
    }
    if (dj) {
      var nom = dj.querySelector('.bn-dj__opt.is-on .bn-dj__name'), sel = nom ? nom.textContent.trim() : '', mias = filas.filter(delProducto);
      return { principal: principal, filas: mias, otro: mias.some(function (f) { return f.con ? opcion(f) === sel : sel === 'Solo dije'; }) };
    }
    var form = btn.closest('form'), input = form && form.querySelector('input[name="id"]'), id = input ? String(input.value) : '';
    var esta = function (f) { return id && vid(f) === id; };
    return { principal: principal, filas: filas.filter(function (f) { return esta(f) || delProducto(f); }), otro: filas.some(esta) };
  }
  function lineaYa(btn, c, m) {
    var el = btn.nextElementSibling;
    if (!el || !el.classList.contains('bn-ya')) {
      el = document.createElement('p');
      el.className = 'bn-ya';
      el.innerHTML = '<span></span> <button type="button">Cambiar</button>';
      el.querySelector('button').addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        if (modo()) { if (window.bnModoAbrir) window.bnModoAbrir(el.__claves || []); }
        else if (window.BovedaCarrito && window.BovedaCarrito.abrir) window.BovedaCarrito.abrir();
        else location.href = '/cart';
      });
      btn.parentNode.insertBefore(el, btn.nextSibling);
    }
    var n = c.filas.reduce(function (s, f) { return s + f.cantidad; }, 0);
    var t = m ? 'Ya está en tu regalo (' + n + ').' : 'Ya está en tu carrito (' + n + ') ·', sp = el.querySelector('span');
    if (sp.textContent !== t) sp.textContent = t;
    el.__claves = c.filas.map(function (f) { return f.clave; });
    return el;
  }
  function correr() {
    var m = modo(), g = m ? regalo(m) : null, filas = m ? (g ? g.filas : []) : sueltas(cart), botones = [], lineas = [];
    var pre = m ? 'al Regalo ' + numero(m, g) : '';
    document.querySelectorAll(SPANS).forEach(function (s) {
      if (s.children.length) return;
      var btn = s.closest('button');
      if (btn && botones.indexOf(btn) < 0) botones.push(btn);
      var t = s.textContent.trim();
      if (conf && conf.span === s) { if (t !== conf.txt) { conf.base = t; s.textContent = conf.txt; } return; }
      var x = RE.exec(t);
      if (!x) return;
      if (/al carrito/i.test(x[1])) ORIGEN.set(s, x[1]);
      var otro = btn && contexto(btn, filas).otro;
      var nuevo = (m ? 'Agregar ' + (otro ? 'otro ' : '') + pre : otro ? 'Agregar otro' : ORIGEN.get(s) || 'Agregar al carrito') + x[2];
      if (t !== nuevo) s.textContent = nuevo;
    });
    botones.forEach(function (b) {
      var c = contexto(b, filas);
      /* El Detox ya tiene su lista «Ya en tu carrito» con Quitar: fuera de un regalo no se repite. */
      if (c.principal && c.filas.length && (m || !c.dx)) lineas.push(lineaYa(b, c, m));
    });
    document.querySelectorAll('.bn-ya').forEach(function (el) { if (lineas.indexOf(el) < 0) el.remove(); });
  }
  function pintar(c) {
    if (c) cart = c;
    var activo = !!(modo() || conf || sueltas(cart).length);
    if (!activo && !visto) return;
    if (activo && !obs) {
      obs = new MutationObserver(function () {
        if (enCola) return;
        enCola = true;
        var listo = false, ir = function () { if (listo) return; listo = true; enCola = false; correr(); };
        requestAnimationFrame(ir); setTimeout(ir, 80);
      });
      obs.observe(document.body, { childList: true, subtree: true, characterData: true });
    } else if (!activo && obs) { obs.disconnect(); obs = null; }
    visto = activo;
    correr();
  }
  /* Solo se llega aquí si el pedido entró: si falla, sale su error y nada más. */
  function marcar() {
    var b = tocado && Date.now() - tocado.t < 8000 ? tocado.btn : null;
    tocado = null;
    if (!b || !document.contains(b)) return;
    var s = [].filter.call(b.querySelectorAll('span'), function (x) { return !x.children.length && !x.classList.contains('sold-out-message') && !x.classList.contains('hidden'); })[0];
    if (!s) return;
    if (conf) terminar();
    var m = modo();
    conf = { btn: b, span: s, base: s.textContent.trim(), txt: m ? '✓ Agregado al Regalo ' + numero(m, regalo(m)) : '✓ Agregado' };
    s.textContent = conf.txt;
    b.classList.add('bn-ok');
    conf.t = setTimeout(function () { terminar(); pintar(); }, 2000);
    pintar();
  }
  function terminar() {
    var c = conf;
    if (!c) return;
    conf = null;
    clearTimeout(c.t);
    c.btn.classList.remove('bn-ok');
    /* El Detox vacía sus cantidades al agregar: sin nada elegido, no hay «otro» que agregar. */
    var dx = c.btn.closest('.bn-dx');
    var vacio = dx && ![].some.call(dx.querySelectorAll('[data-n]'), function (n) { return parseInt(n.textContent, 10) > 0; });
    c.span.textContent = vacio ? 'Elige una opción arriba' : c.base;
  }
  /* Quién agregó: el aviso no lo dice. Tocar durante la confirmación no agrega otra vez por accidente. */
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest(BOTON);
    if (!b) return;
    if (conf && conf.btn === b) { e.preventDefault(); e.stopImmediatePropagation(); return; }
    tocado = { btn: b, t: Date.now() };
  }, true);
  window.addEventListener('bn:agregado', marcar);
  window.addEventListener('bn:regalo-agregado', marcar);
  window.addEventListener('bn:carrito', function (e) { pintar(e.detail.cart); });
  window.addEventListener('bn:regalo-modo', function () { pintar(); });
  /* Dawn avisa el cambio de variante con un change. */
  document.addEventListener('change', function () { if (visto) setTimeout(correr, 0); });
  window.bnBoton = { pintar: pintar };
  pintar();
})();
